import { createContext } from 'react'

import { CYPRESS_OPTIONS, IS_CYPRESS } from 'src/utils/misc'

export const UserEmailContext = createContext({
    userEmail: IS_CYPRESS ? CYPRESS_OPTIONS.headers['x-cypress-email'] : null,
})

export default UserEmailContext
